import { forwardRef, type Ref, type SVGProps } from "react";
const IconMessageHeartFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27 3H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h3v6a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l6.7-6.71H27a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3m-6.82 9.87-4 4.05a.33.33 0 0 1-.44 0l-4-4.05a2.9 2.9 0 0 1 0-4 2.76 2.76 0 0 1 3.95 0l.23.24.23-.24a2.76 2.76 0 0 1 3.95 0 2.9 2.9 0 0 1 .08 4"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMessageHeartFilledSVG);
ForwardRef.displayName = "IconMessageHeartFilled";
export { ForwardRef as IconMessageHeartFilled };
